import { useQuery } from "@tanstack/react-query";
import {
  ServiceObjectTableQuery,
  ServiceObjectUpcomingRevisionsTableQuery,
} from "./models";
import { getTableQueryKey } from "../../helpers/tableHelpers";
import serviceObjectsClient from "../../api/private/serviceObjectsClient";
import {
  CPServiceObjectDetail,
  TableResultCPServiceObject,
  TableResultCPUpcomingServiceObjectRevision,
} from "../../api/models/unified";

const serviceObjectsKey = "serviceObjectsKey";
const serviceObjectDetailKey = "serviceObjectDetailKey";
const upcomingServiceObjectRevisionsKey = "upcomingServiceObjectRevisionsKey";

const getServiceObjectDetailQueryKeyBuilder = (id: string) => [
  serviceObjectDetailKey,
  id,
];

export const useGetServiceObjectsQuery = (params: ServiceObjectTableQuery) => {
  return useQuery<TableResultCPServiceObject>({
    queryKey: getTableQueryKey(serviceObjectsKey, params),
    queryFn: () => serviceObjectsClient.getServiceObjects(params),
  });
};

export const useGetUpcomingServiceObjectRevisionsQuery = (
  params: ServiceObjectUpcomingRevisionsTableQuery,
) => {
  return useQuery<TableResultCPUpcomingServiceObjectRevision>({
    queryKey: getTableQueryKey(upcomingServiceObjectRevisionsKey, params),
    queryFn: () => serviceObjectsClient.getUpcomingRevisions(params),
  });
};

export const useGetServiceObjectDetailQuery = (id?: string) => {
  return useQuery<CPServiceObjectDetail>({
    queryKey: getServiceObjectDetailQueryKeyBuilder(id ?? ""),
    queryFn: () => serviceObjectsClient.getServiceObjectDetail(id ?? ""),
    enabled: !!id,
  });
};
